import { useState } from 'react';
import { isNil } from 'ramda';
import DeleteDocumentMutation from '../_graphql/mutations/documents/DeleteDocumentMutation';
import DeleteRawDocumentMutation from '../_graphql/mutations/documents/DeleteRawDocumentMutation';
import DeleteRawDocumentsMutation from '../_graphql/mutations/documents/DeleteRawDocumentsMutation';
import PreviewDocumentHtmlMutation from '../_graphql/mutations/documents/PreviewDocumentHtmlMutation';
import PreviewDocumentMutation from '../_graphql/mutations/documents/PreviewDocumentMutation';
import { deleteMutationMessage, errorMessage } from '../utils/messageMutation';
import DeleteDocumentsMutation from '../_graphql/mutations/documents/DeleteDocumentsMutation';

export const useDocumentsTable = () => {
  const [documentToCopy, setDocumentToCopy] = useState({});
  const [previewHtml, setPreviewHtml] = useState();
  const [documentPreviewUrl, setDocumentPreviewUrl] = useState();
  const [documentIdModalToShow, setDocumentIdModalToShow] = useState();

  const deleteDocument = (documentId, cb) => () => DeleteDocumentMutation({ documentId }, (ok, error) => deleteMutationMessage(ok, error, 'document', cb));

  const deleteDocuments = (documentsIds, cb) => DeleteDocumentsMutation({ documentsIds }, cb);

  const deleteRawDocument = (rawDocumentId, cb) => DeleteRawDocumentMutation({ rawDocumentId }, cb);

  const deleteRawDocuments = (rawDocumentsIds, cb) => DeleteRawDocumentsMutation({ rawDocumentsIds }, cb);

  const previewDocumentHtml = (documentId) => {
    setPreviewHtml(undefined);
    setDocumentIdModalToShow(undefined);

    PreviewDocumentHtmlMutation({ variables: '{}', documentId }, (ok, error, pagesHtml) => {
      if (ok && !error) {
        setPreviewHtml(pagesHtml);
        setDocumentIdModalToShow(documentId);
      } else {
        errorMessage();
      }
    });
  };

  const previewDocument = (pages, variables, padding, documentId) => {
    variables = isNil(variables) ? '[]' : JSON.stringify(variables);
    PreviewDocumentMutation({
      pages,
      variables,
      padding,
      documentId
    }, (ok, error, url) => {
      if (ok && !error) {
        setDocumentPreviewUrl(url);
      } else {
        errorMessage();
      }
    });
  };

  return {
    setDocumentToCopy,
    documentToCopy,
    documentIdModalToShow,
    deleteDocument,
    deleteDocuments,
    deleteRawDocument,
    deleteRawDocuments,
    previewHtml,
    setPreviewHtml,
    previewDocumentHtml,
    previewDocument,
    documentPreviewUrl
  };
};

export default useDocumentsTable;
